<template>
  <ion-card
    class="border-default no-shadow spacing-xs filter-card ion-no-margin bg-white"
    v-if="contract"
  >
    <div class="d-flex align-center">
      <div
        class="info-btn"
        :style="`background-color: ${statusOptions[contract.status as keyof typeof statusOptions].accent}`"
      >
        <ion-icon
          :icon="statusOptions[contract?.status as keyof typeof statusOptions].icon"
          :color="statusOptions[contract?.status as keyof typeof statusOptions].color"
          class="info-icon"
        ></ion-icon>
      </div>

      <p v-if="contract?.status == 'pending'" class="font-sm px-xs">
        {{ t(`profile.document.signNowDescription`) }}
      </p>

      <p v-if="contract?.status == 'signed_by_owner'" class="font-sm px-xs">
        {{ t(`profile.document.signNowDescription`) }}
      </p>
    </div>

    <ion-button
      :disabled="contract?.status !== 'signed_by_owner'"
      @click="router.push({ name: 'reservationDocuments', params: { bookingId: bookingId } })"
      fill="solid"
      expand="block"
      size="default"
      color="primary"
      class="text-lg text-weight-bold mt-xs w-100"
    >
      {{
        contract?.status == 'signed_by_owner'
          ? t('profile.document.signNow')
          : t('profile.document.pendingSignByOwner')
      }}
    </ion-button>
  </ion-card>
</template>

<script setup lang="ts">
  import router from '@/router';
  import { IonCard, IonIcon, IonButton } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { pencilOutline } from 'ionicons/icons';
  import { IContractData } from '@/interfaces/booking/booking.interface';

  withDefaults(
    defineProps<{
      contract?: IContractData;
      bookingId: string;
    }>(),
    {},
  );

  const statusOptions = {
    pending: { accent: 'var(--ion-color-warning-tint)', color: 'warning', icon: pencilOutline },
    signed_by_owner: {
      accent: 'var(--ion-color-error-tint)',
      color: 'warning',
      icon: pencilOutline,
    },
  };

  const { t } = useI18n();
</script>

<style lang="css" scoped>
  .info-icon {
    height: 20px;
    width: 20px;
  }
</style>
